import audioFile from '../assets/audio/notify.wav'
import icon from '../assets/img/BeOn.png'
import {notificationAddLocalRequest, notificationSocketSetter} from "../store/actions/notification.js"
import Api from "../Api.js";
import {REACT_SOCKET_URL} from '../config.js'
import {managerNotifyRequest} from "../store/actions/manager.js";

let socket = null;
let reconnectTimeout = null;

const playNotificationSound = () => {
    const audio = new Audio(audioFile);
    audio.play().catch((error) => console.error("🔇 Error playing notification sound:", error));
};

const showBrowserNotification = (data) => {
    if (document.hidden && Notification.permission === "granted") {
        const notification = new Notification("📢 BeOn New Notification", {
            body: data.message || "You have a new alert",
            icon: icon,
        });
        notification.onclick = function (event) {
            event.preventDefault();
            localStorage.setItem('redirectOnFocus', `/main_employee/notification/${data.notification.id}`); // Or dynamic: `/tasks/${data.task_id}`
            window.focus();
            window.location.href = `/main_employee/notification/${data.notification.id}`; // Or dynamic: `/tasks/${data.task_id}`
        };
    }


};

export const connectNotificationSocket = (token, dispatch) => {
    const WS_URL = `${REACT_SOCKET_URL}/ws/notifications/?token=${token}`;

    socket = new WebSocket(WS_URL);

    socket.onopen = () => {
        console.log("✅ Notification WebSocket connected");
        dispatch(notificationSocketSetter('on'));
        if (reconnectTimeout) {
            clearTimeout(reconnectTimeout);
            reconnectTimeout = null;
        }
    };

    socket.onmessage = async (event) => {
        const data = JSON.parse(event.data);
        console.log("🔔 New notification received:", data);
        if (data.notification) {
            if (window.location.pathname === '/main_employee/notification') {
                const notification = await Api.getNotification(window.location.search.substring(1))
                dispatch(notificationAddLocalRequest(notification.data.results));
            }
            if((data.notification.manager_notification && +data.notification.manager_notification.user_id !== +localStorage.getItem('user_id') )
            || (data.notification.accountant_list && data.notification.accountant_list.find(accountant => accountant.user_id === +localStorage.getItem('user_id')))){
                playNotificationSound();
                showBrowserNotification(data);
                await dispatch(managerNotifyRequest(true));
            }

        }
    };

    socket.onclose = () => {
        dispatch(notificationSocketSetter('reconnect'));

        console.warn("⚠️ Notification WebSocket disconnected, attempting to reconnect...");
        reconnectNotificationSocket(token, dispatch);
    };

    socket.onerror = (error) => {
        dispatch(notificationSocketSetter('off'));

        console.error("❌ Notification WebSocket error:", error);
        socket.close();
    };
};

export const reconnectNotificationSocket = (token, dispatch) => {
    if (!reconnectTimeout) {
        reconnectTimeout = setTimeout(() => {
            console.log("♻️ Reconnecting Notification WebSocket...");
            connectNotificationSocket(token, dispatch);
        }, 3000);
    }
};

export const disconnectNotificationSocket = () => {
    if (socket) {
        socket.close();
    }
};
